// frontend/src/components/UserProfile.js
import React, { useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Typography, Box,
    CircularProgress, AppBar, Toolbar, useMediaQuery // Hinzugefügt
} from '@mui/material';
import { useTheme } from '@mui/material/styles'; // Hinzugefügt
import CloseIcon from '@mui/icons-material/Close';
import TableSettings from './TableSettings';
import { useUserPreferences } from '../context/UserPreferencesContext';

function UserProfile({ open, onClose }) {
  const {
      userProfile, columns, allColumnsConfig,
      isLoadingProfile, isSavingPreferences,
      error, fetchProfile, savePreferences
  } = useUserPreferences();

  const theme = useTheme(); // Hinzugefügt
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Hinzugefügt

  useEffect(() => {
    if (open) { fetchProfile(); }
  }, [open, fetchProfile]);

  const isLoadingContent = isLoadingProfile;
  const isActionLoading = isSavingPreferences;

  return (
    <Dialog open={open} onClose={onClose} fullScreen={isMobile} fullWidth maxWidth="md">
      {/* Mobile Header */}
      {isMobile && (
          <AppBar sx={{ position: 'relative' }}>
              <Toolbar>
                  <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close" disabled={isActionLoading}>
                      <CloseIcon />
                  </IconButton>
                  <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                      Profil & Einstellungen
                  </Typography>
                  {/* Save Button wird in TableSettings gerendert */}
                  <Button color="inherit" onClick={onClose} disabled={isActionLoading}>
                      Schließen
                  </Button>
              </Toolbar>
          </AppBar>
      )}
      {/* Desktop Title */}
      {!isMobile && (
          <DialogTitle sx={{ m: 0, p: 2, bgcolor: 'primary.main', color: 'white' }}>
              Benutzerprofil & Einstellungen
              <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }} disabled={isActionLoading}>
                  <CloseIcon />
              </IconButton>
          </DialogTitle>
      )}

      <DialogContent sx={isMobile ? { pt: 2 } : {}}>
        {isLoadingContent && <CircularProgress sx={{ display: 'block', margin: '20px auto' }} />}
        {error && <Typography color="error">Fehler: {error}</Typography>}
        {!isLoadingContent && userProfile && (
          <Box sx={{ opacity: isActionLoading ? 0.7 : 1 }}>
            <Typography variant="h6" gutterBottom>E-Mail: {userProfile.email}</Typography>
            <Box mt={3}>
              <TableSettings
                  savePreferences={savePreferences}
                  initialColumns={columns}
                  allColumnsConfig={allColumnsConfig}
                  isSavingPreferences={isSavingPreferences}
                  isMobile={isMobile} // Übergeben für internes Layout
              />
            </Box>
          </Box>
        )}
      </DialogContent>
      {/* Desktop Actions */}
      {!isMobile && (
          <DialogActions>
              <Button onClick={onClose} disabled={isActionLoading}>Schließen</Button>
              {/* Save Button ist in TableSettings */}
          </DialogActions>
      )}
    </Dialog>
  );
}

export default UserProfile;
